import {Component} from '@angular/core';
import {Api} from "../../providers/api";
import { NavController,ModalController,ToastController} from 'ionic-angular';
import {CartManager} from "../../providers/cart-manager";
import {MsgManager} from "../../providers/msg-manager";
import {SpinnerDialog} from "ionic-native";
import {GVLogger} from "../../services/gv-logger";
import {LoginPage} from "../login/login";


@Component({
  selector: 'categories',
  templateUrl: 'categories.html'
})
export class CategoriesPage{

	private categories:any = [];

	itemExpandHeight: number = 100;


	constructor(
		private api:Api,
		private nav:NavController,
		private modalController:ModalController,
		private cartManager:CartManager,
		private msgManager:MsgManager,
		private toastController:ToastController,
    private gVLogger: GVLogger
		){

		this.api.get("category/allActiveInactive").map(res => res.json())
	    .subscribe(data =>{
        if(data.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

          this.nav.setRoot(LoginPage);
        }

	    		this.gVLogger.log(data.data);

	    		var tempCate = [];

	    		for(let col of data.data){

	    			col.subCategories = [];
	    			if(col.categoryType =="COLLECTION"){
	    				tempCate.push(col);
		    			if( col.parentId == 0){
		    				col.expanded = false;
		    				this.categories.push(col);
		    				this.gVLogger.log(col);
		    			}
	    			}
	    		}

	    		for(let cat of this.categories){

	    				this.gVLogger.log("CHILD"+cat);
		    			for(let tCat of tempCate){
		    				if(cat.id == tCat.parentId){
		    					cat.subCategories.push(tCat);
		    				}

	    			}
	    		}

	    		for(let c of this.categories){

	    			if(c.subCategories.length > 0){
	    				for(let s of c.subCategories){
	    					s.parent = c;
	    					this.categories.push(s);
	    				}
	    			}
	    		}
	    });
	}

	 expandItem(item){
	 	this.gVLogger.log(item);

        for(let listItem of this.categories) {

            if(item == listItem){
                listItem.expanded = !listItem.expanded;
                 item =  listItem;
            } else {
                listItem.expanded = false;
           }
        }
        	this.gVLogger.log(item);
    }


	toggleStatus(cat){
		let tempState = cat.displayOnScreen;
		this.gVLogger.log("temmmmmmpp"+tempState);
		let tempStateInverse;
		if(tempState == 0){
			tempStateInverse = 1;
		}else{
			tempStateInverse = 0;
		}
		this.gVLogger.log("tempStateInverse......"+ tempStateInverse);

		if (tempState == true) {
			tempState = 1
		}else{
			tempState = 0
		}

		 let body = cat;
	        body.id =  cat.id;
	       body.displayOnScreen = tempState;


	    this.gVLogger.log("body: "+body);
	    this.gVLogger.log("cat: "+cat);
		SpinnerDialog.show(this.msgManager.getLoadingMsg());


		this.api.post("category/update", body).map(res => res.json()).subscribe(result =>{
			this.gVLogger.log("Enter in resolve"+ result);
		if(result.status == "200"){
			this.gVLogger.log("if executed")
		this.toastMsg(result.message);
		}else{
			this.gVLogger.log("else executed");
			this.toastMsg(result.message);
			cat.displayOnScreen = tempStateInverse;
		}
		SpinnerDialog.hide();
		}, error =>{
			this.gVLogger.log("error............!!!!!!!!!!"+ JSON.stringify(error));
		this.toastMsg(this.msgManager.getWentWrongMsg());
		cat.displayOnScreen = tempStateInverse;
		SpinnerDialog.hide();
		});
	}


toastMsg(msg){
    let taost = this.toastController.create({
        message: msg,
        duration: 3000
    });
    taost.present();
  }


}



// WEBPACK FOOTER //
// ./src/pages/categories/categories.ts